export const items = (state) => state.season;
export default (state, props) => state.season[props.id];
